/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, useImperativeHandle, Fragment } from 'react';
import { useSelector } from "react-redux";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { capitalizeFirstLetter, getColumnWidth, idNamingConversion, checkComponentPermission, currencyFormat } from '../../../../../helpers/utilities';
import { Space, Image } from "antd";
import { Button, Box } from "@mui/material";
import { NavLink } from "react-router-dom";
import { HeaderView, LinesList, DeliveryChallan } from "./Blocks";
import crudActions from "../../../../CRUD/redux/actions";
import unitActions from "../../../Setup/redux/actions";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { Link, } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import productActions from "../../../Product/redux/actions";
import productSetupActions from "../../../Setup/redux/actions";
import { toast } from 'react-toastify';
import { getRequest } from '../../../../../helpers/axiosClient';
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import dayjs from 'dayjs';
import { emptyValidation } from "../../../../../helpers/validation";
import moment from 'moment';



export const CustomForm = React.forwardRef((props, ref) => {
    const { businessDetails, parameterDetails } = useSelector(state => state.homeReducer);
    const { view, stockId, showDetails, type, clsx, history, dispatch, classes, roleManagement } = props;
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, createData } = useSelector(state => state.crudReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { unitMesurementdetails, locationDetails } = useSelector(state => state.productSetupReducer);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const childRef = useRef('');
    const formRef = useRef('');
    const [search, setSearch] = useState('');
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);


    const [form, setForm] = useState({
        createTs: new Date()
    });
    const [error, setError] = useState({});
    const [batch, setBatch] = useState([]);
    const [confirm, setConfirm] = useState('');
    const [visible, setVisible] = useState(false);
    const [status, setStatus] = useState('CREATED');
    const [lines, setLines] = useState([]);
    const [linesSearch, setLinesSearch] = useState([]);


    useEffect(() => {
        loadTasks();
        return () => {
            dispatch({ type: productActions.CLEAR_PRICE_START });
        };
    }, []);

    useEffect(() => {
        setLinesSearch(lines);
    }, [lines]);

    const loadTasks = () => {
        locationApi();
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
    };

    const handleSubmit = (e, status = 'CREATED') => {
        e.preventDefault();
        handleCommonSubmit(status);
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                setLinesSearch(lines);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    setLinesSearch(lines?.filter((el) => {
                        const regex = new RegExp(search, "i");
                        return (
                            el?.product?.productName?.match(regex) ||
                            el?.product?.productId?.match(regex) ||
                            el?.unit?.name?.match(regex) ||
                            el?.location?.name?.match(regex) ||
                            String(el?.amount ?? "").match(regex) ||
                            String(el?.pricePerUnit ?? "").match(regex) ||
                            String(el?.quantity ?? "").match(regex)
                        );
                    }));
                }, 500);
            }
        }
    }, [search]);

    const handleCommonSubmit = (status, callDispatch = true) => {
        childRef?.current?.handleAdjustHeight();
        let aL = [];
        setError({});
        let lineError = { isValid: true, errors: '' };
        let emptyLocation = emptyValidation('Location', form?.locationId, 'dropDown');
        let emptyToLocation = emptyValidation('To Location', form?.toLocationId, 'dropDown');
        let transitError = { isValid: true, errors: '' };

        if (form?.location?.inTransit || form?.toLocation?.inTransit) {
            if (form?.location?.transitId !== form?.toLocation?.transitId) {
                transitError = { isValid: false, errors: 'Transit location selected between Selected Transfer location is different . Please select common Transit location in Location setup for Transfer orders to be executed.' };
            }
        }


        lines?.forEach((element) => {
            if (element.quantity === '' || element.toQuantity == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} quantity field can't be blank` };
            }
            if (element.locationId === '' || element.locationId == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} location field can't be blank` };
            }
            if (element.toLocationId === '' || element.toLocationId == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} To Location field can't be blank` };
            }
            if (element.unitId === '' || element.unitId == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} unit field can't be blank` };
            }

            if (element?.location?.inTransit || element?.toLocation?.inTransit) {
                if (element?.location?.transitId !== element?.toLocation?.transitId) {
                    lineError = { isValid: false, errors: `Line Number ${element.lineNumber} Transit location selected between Selected Transfer location is different . Please select common Transit location in Location setup for Transfer orders to be executed.` };
                }
            }


            if (element?.batchDetails?.length > 0 && element?.batchOverride) {
                let batchQuantity = element?.batchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.toQuantity || 0)), 0);
                if ((status === 'SHIPPED' || status === 'CREATED') && batchQuantity !== parseFloat(element?.toQuantity)) {
                    lineError = { isValid: false, errors: `Line Number ${element.lineNumber} Total Batch quantity should equal Line Quantity` }
                }
                let batchRecQuantity = element?.batchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.receivedQuantity || 0)), 0);
                if (status === 'RECEIVED' && batchRecQuantity !== parseFloat(element?.receivedQuantity)) {
                    lineError = { isValid: false, errors: `Line Number ${element.lineNumber} Total Batch quantity should equal Line Quantity` }
                }
            }
        });

        if (lineError?.isValid && emptyLocation?.isValid && emptyToLocation?.isValid && transitError?.isValid) {
            lines && lines?.length > 0 && lines?.map((element, i) => {
                return aL.push({ ...element })
            });
            form.shippedDate = form.shippedDate ? moment(form.shippedDate).format("YYYY-MM-DDT00:00:00.000+00:00") : moment(new Date()).format("YYYY-MM-DDT00:00:00.000+00:00");

            form.receivedDate = form.receivedDate ? moment(form.receivedDate).format("YYYY-MM-DDT00:00:00.000+00:00") : moment(new Date()).format("YYYY-MM-DDT00:00:00.000+00:00");

            if (callDispatch) {
                form.transferStatus = status || null;
                let subForm = { ...form };

                if (Array.isArray(aL) && aL.length > 0) {
                    aL.forEach(element => {
                        delete element.location;
                        delete element.product; delete element.toLocation;
                        delete element.unit; delete element.batch;


                        if (status === 'RECEIVED') {
                            element.balanceQuantity = parseFloat((element?.balanceQuantity || 0)) - parseFloat((element?.receivedQuantity || 0));
                        } else {
                            element.balanceQuantity = parseFloat((element?.toQuantity || 0))
                        }

                        if (status === 'RECEIVED' && parseFloat(element.balanceQuantity) === 0) {
                            element.lineStatus = 'RECEIVED';
                        } else if (status === 'SHIPPED') {
                            element.lineStatus = 'SHIPPED';
                        }

                        if (Array.isArray(element.batchDetails) && element.batchDetails.length > 0) {
                            // Keep only those with toQuantity > 0
                            element.batchDetails = element.batchDetails.filter(e => e.toQuantity && e.toQuantity !== 0);

                            // Clean up extra fields
                            element.batchDetails.forEach(e => {
                                if (status === 'RECEIVED') {
                                    e.balanceQuantity = parseFloat((e?.balanceQuantity || 0)) - parseFloat((e?.receivedQuantity || 0));
                                } else {
                                    e.balanceQuantity = parseFloat((e?.toQuantity || 0))
                                }
                                delete e.currentStock;
                            });

                            // If the array becomes empty after filtering, remove it
                            if (element.batchDetails.length === 0) {
                                delete element.batchDetails;
                            }
                        } else {
                            delete element.batchDetails; // remove if empty or not an array
                        }
                    });
                }

                subForm.stockTransferItems = aL;
                delete subForm.createTs; delete subForm.updateTs;
                delete subForm.shippedBy; delete subForm.receivedBy; delete subForm.toLocation; delete subForm.location; delete subForm.updatedBy; delete subForm.createdBy; delete subForm.business;
                dispatch({
                    type: subForm?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                    url: 'stockTransfer',
                    title: 'Stock Transfer',
                    id: subForm?.id,
                    details: subForm
                })
            } else {
                return form
            }
        } else {
            if (lineError?.errors || transitError?.errors) {
                toast.dismiss();
                toast.error(lineError?.errors || transitError?.errors);
            }
            setError({
                locationId: emptyLocation?.errors || false,
                toLocationId: emptyToLocation?.errors || false,
            })
        }
    }

    const customObject = (details, id) => {
        let a = details && details?.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    const deleteLine = async (index) => {
        // Find the line at the given index
        const line = lines[index];
        if (!line) return;

        try {
            // If the line exists in DB (has an id), call backend API
            if (line.id) {
                await dispatch({
                    type: crudActions.DELETE_DETAILS_START,
                    url: `stockTransferLines/delete`,  // use RESTful route
                    id: line?.id,                // ensure DELETE request
                    title: 'Stock Transfer Line',
                });
            }

            // Remove from local state
            const updatedLines = lines.filter((_, i) => i !== index);
            setLines(updatedLines);

        } catch (error) {
            console.error('Error deleting line:', error);
            toast.error('Failed to delete line. Please try again.');
        }
    };

    const handleBulkDelete = (selected) => {
        setLines((prevLines) => prevLines.filter(
            (line) => !selected.includes(line.lineNumber)
        ));
        let ids = lines.filter(line => selected.includes(line.lineNumber) && line?.id).map(line => line.id);
        if (ids?.length > 0) {
            dispatch({
                type: crudActions.DELETE_DETAILS_START,
                url: 'stockTransferLines/deleteByIds',
                title: 'Stock Transfer Lines',
                details: ids
            });
        }
        formRef.current.handleSelected([]);
    };

    const lineSubmit = (data, lineId = '') => {
        if (lineId !== '') {
            let index = lines.findIndex((d, i) => lineId === i);
            if (index >= 0) {
                lines.splice(index, 1, data);
            }
        } else {
            setLines((prevState) => {
                return [...prevState, data];
            });
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            setConfirm('');
            setStatus(form.adjustmentStatus);
            history.push(`/product/inventory/stock-transfer/${AESEncrypt(createData.id)}/view`, `create`);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            //setCommonError(error);
            toast.dismiss();
            toast.error(error);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            setConfirm('');
            setStatus(form.transferStatus);
            history.push(`/product/inventory/stock-transfer/${AESEncrypt(stockId)}/view`, `${type}`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            let text = editError.error.message;
            toast.error(text);
        }
        childRef?.current?.handleAdjustHeight();
    }, [editDetails, editError]);


    const createProduct = (filterForm) => {
        let filter = [];

        if (filterForm.productId) {
            filter.push({ productId: filterForm.productId });
        }

        if (filterForm.groupId) {
            filter.push({ productGroupId: filterForm.groupId });
        }

        if (filterForm.type) {
            filter.push({ type: filterForm.type });
        }

        if (filterForm.locationId) {
            filter.push({ locationId: filterForm.locationId });
        }

        getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/customFilter?customFilter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    let lineNumber = (lines?.length ?? 0) + 1;

                    const groupedData = Object.values(
                        uData.reduce((acc, el) => {
                            const productId = el.product?.id || null;
                            if (!productId) return acc;

                            // Initialize group if not exist
                            if (!acc[productId]) {
                                acc[productId] = {
                                    product: el.product || null,
                                    productId,
                                    quantity: 0,
                                    toQuantity: 1,
                                    pricePerUnit: parseFloat(el?.costPrice) || 0,
                                    amount: 0,
                                    unitId: el.unitId || null,
                                    unit: el.unit || null,
                                    locationId: el.locationId || null,
                                    location: el.location || null,
                                    toLocationId: form.toLocationId || null,
                                    toLocation: form.toLocation || null,
                                    batchOverride: el.product?.batchActivation || false,
                                    batchDetails: [],
                                };
                            }

                            // Prepare batch info
                            if (el.batch) {
                                if (el.batch.availableStock > 0) {
                                    const batch = {
                                        batchNumber: el.batch?.batchNumber || '',
                                        batchId: el.batch?.id || '',
                                        manufacturingDate: el.batch?.manufacturingDate || null,
                                        expiryDate: el.batch?.expiryDate || null,
                                        useByDate: el.batch?.useByDate || null,
                                        bestBeforeDate: el.batch?.bestBeforeDate || null,
                                        perUnitPrice: el.batch?.perUnitPrice || '',
                                        mrp: el.batch?.mrp || '',
                                        availableStock: el.batch?.availableStock || '',
                                        toQuantity: '',
                                        productId: el.batch?.productId || '',
                                        universalProductId: el.batch?.universalProductId || '',
                                        locationId: el.batch?.locationId || '',
                                        toLocationId: form?.toLocationId || '',
                                    }
                                    acc[productId].batchDetails.push(batch);
                                }
                            }

                            // Aggregate stock and amount
                            const physicalQty = parseFloat(el.physicalQtyUnit) || 0;
                            const costPrice = parseFloat(el.costPrice) || 0;

                            acc[productId].quantity += physicalQty; // equivalent to 0 - physicalQty
                            acc[productId].amount = 1 * costPrice;

                            return acc;
                        }, {})
                    );
                    // Assign line numbers and push to state
                    // const updatedData = groupedData.map((item) => {
                    //     const updatedItem = {
                    //         ...item,
                    //         lineNumber: lineNumber++,
                    //     };
                    //     if (updatedItem.batchDetails?.length) {
                    //         updatedItem.batchDetails = [...updatedItem.batchDetails];
                    //         updatedItem.batchDetails[0] = {
                    //             ...updatedItem.batchDetails[0],
                    //             toQuantity: 1,
                    //         };
                    //     }
                    //     return updatedItem;
                    // });
                    console.log(groupedData);
                    const updatedData = groupedData.map((item) => {
                        const updatedItem = {
                            ...item,
                            lineNumber: lineNumber++,
                        };

                        if (Array.isArray(updatedItem.batchDetails) && updatedItem.batchDetails.length > 0) {
                            updatedItem.batchDetails = updatedItem.batchDetails.map((batch, index) => {
                                if (index === 0) {
                                    return { ...batch, toQuantity: 1 };
                                }
                                return batch; // leave other batches as is
                            });
                        }

                        return updatedItem;
                    });
                    setLines((prev) => [...prev, ...updatedData]);
                    formRef.current.handleFilterForm();
                }
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    useImperativeHandle(ref, () => ({
        onEdit(data) {
            setForm({
                ...data,
                shippedDate: data?.shippedDate ? dayjs(data?.shippedDate).$d : null,
                receivedDate: data?.receivedDate ? dayjs(data?.receivedDate).$d : null,
            });
            setStatus(data?.transferStatus);
            if (data?.stockTransferItems) {
                setTimeout(() => {
                    const products = data?.stockTransferItems?.map(el => el?.product).filter(Boolean); // remove null/undefined
                    const updated = data?.stockTransferItems?.map(el => {
                        return {
                            ...el,
                            receivedQuantity: el?.lineStatus === 'SHIPPED' ? (el.balanceQuantity ?? 0) : el?.lineStatus === 'RECEIVED' ? (el.toQuantity ?? 0) : 0
                        };
                    });
                    data.stockTransferItems = updated;
                    setLines(data?.stockTransferItems);
                    // Call handleBulkUnits once for all products
                    formRef.current.handleBulkUnits(products);
                })
            }
        }
    }))

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        filter['and'].push(or);
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const productGroupApi = () => {
        dispatch({
            type: productSetupActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups',
            filter: {
                order: 'id desc'
            },
        });
    }

    const changeHandlerLine = (data, e, name = '', relation = '') => {
        const newTodos = lines.map((el) => {
            if (el.lineNumber === data.lineNumber) {
                if (relation !== '') {
                    const d = { ...el, [name]: e.id, [relation]: e };
                    return d;
                } else {
                    const d = { ...el, [name]: e };
                    return d;
                }
            }
            return el; // ✅ keep other rows unchanged
        });

        setLines(newTodos);
    };

    const handleConfirmSubmit = (e, status) => {
        e.preventDefault();
        let data = handleCommonSubmit(status, false);
        if (data) {
            setConfirm(status);
        }
    }


    const changeHandlerBatch = (e, name, i) => {
        // Create a shallow copy of the array
        const updatedArr = [...batch];

        // Update the specific element immutably        
        updatedArr[i] = {
            ...updatedArr[i],
            [name]: e,
        };

        const newArr = updatedArr.map(el => ({
            ...el,

        }));

        setBatch(newArr);
    };

    const onDeletBatch = (data) => {
        let selectedSIngleIndex = batch?.findIndex(el => el.batchNumber === data.batchNumber);
        if (selectedSIngleIndex >= 0) {
            setBatch(prevState => {
                return prevState.filter((value, i) => i !== selectedSIngleIndex)
            });
            // setErrorBatchQuantity(false);
        }
        return false;
    }

    const handleDocument = () => {
        console.log(businessDetails);
        setForm({
            ...form,
            businessId: form?.businessId || businessDetails?.businessId || null,
            business: form?.business || businessDetails || null,
            transferStatus: form?.transferStatus || status || 'CREATED',
            stockTransferItems: lines || form?.stockTransferItems || [],
        });
        setVisible(true);
    }


    return (
        <Fragment>
            <CustomAccordion
                title={`${capitalizeFirstLetter(type)} Stock Transfer`}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline, classes.positionRelative)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => handleSubmit(e, status)}>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <>
                                <div className={clsx(classes.tabWrapSubmit)}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkComponentPermission('Stock Transfer', 'Page', 'Delivery Challan') &&
                                            (status === 'SHIPPED' || status === 'CREATED' || status === 'RECEIVED') && form?.locationId && form?.toLocationId &&
                                            lines.length > 0 &&
                                            <NavLink to="#" onClick={() => handleDocument()} tabIndex={-1}>
                                                <Image tabIndex={-1} className={""} src={ViewIcon} preview={false} />
                                                <span className={classes.customerInvoiceNone} style={{ marginLeft: 5 }}>View Document</span>
                                            </NavLink>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Stock Transfer', 'Page', 'Shipped') && status === 'CREATED' &&
                                            <Button
                                                tabIndex={-1}
                                                key="confirm"
                                                color="primary"
                                                variant="contained"
                                                id={idNamingConversion('Confirm', 'stockTransfer', 'Button')}
                                                onClick={(e) => handleConfirmSubmit(e, 'SHIPPED')}
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader }, { [classes.disabled]: lines.length === 0 })}
                                            >Shipped</Button>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Stock Transfer', 'Page', 'Received') && status === 'SHIPPED' &&
                                            <Button
                                                tabIndex={-1}
                                                key="confirm"
                                                color="primary"
                                                variant="contained"
                                                id={idNamingConversion('Confirm', 'stockTransfer', 'Button')}
                                                onClick={(e) => handleConfirmSubmit(e, 'RECEIVED')}
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader }, { [classes.disabled]: lines.length === 0 })}
                                            >Received</Button>
                                        }
                                        {
                                            (status === 'CREATED') && <>
                                                {
                                                    (type === 'edit' || type === 'create') ? <Button
                                                        tabIndex={-1}
                                                        key="Save"
                                                        type="submit"
                                                        color="primary"
                                                        variant="contained"
                                                        id={idNamingConversion('Save', 'stockTransfer', 'Button')}
                                                        className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader })}
                                                    >{type === 'create' ? 'Save' : 'Update'}</Button> : <Link
                                                        to={`/product/inventory/stock-transfer/${AESEncrypt(stockId)}/edit`}
                                                        id={idNamingConversion('Edit', 'stockTransfer', 'Link')}
                                                        className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0, { [classes.loadingA]: editLoader || createLoader })}>Edit</Link>
                                                }
                                            </>
                                        }
                                    </Space>
                                </div>
                                <div className={classes.tabDesign}>
                                    <HeaderView {...props}
                                        form={form}
                                        view={view}
                                        status={status}
                                        capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                                        idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                        customObject={(details, id) => customObject(details, id)}
                                        locationDetails={locationDetails}
                                        error={error}
                                        changeHandler={(data, name, relation = '') => {
                                            if (relation) {
                                                setForm({
                                                    ...form, [relation]: data, [name]: data.id
                                                })
                                            } else {
                                                setForm({
                                                    ...form, [name]: data
                                                })
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        }
                    </Box>
                }
            />
            <CustomAccordion
                title={'Stock Transfer Lines'}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={
                    <>
                        {
                            showDetails ? <div className={classes.textAlignCenter
                            } >
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <LinesList
                                {...props}
                                classes={classes}
                                form={form}
                                ref={formRef}
                                type={type}
                                useEventListener={useEventListener}
                                idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                clsx={clsx}
                                lines={linesSearch}
                                dispatch={dispatch}
                                customObject={(details, id) => customObject(details, id)}
                                productApi={(s = '', id = '') => productApi(s, id)}
                                productGroupApi={() => productGroupApi()}
                                productActions={productActions}
                                productGroupDetails={productGroupDetails}
                                myProductdetails={myProductdetails}
                                businessDetails={businessDetails}
                                unitMesurementdetails={unitMesurementdetails}
                                getColumnWidth={(head, v) => getColumnWidth(head, v)}
                                deleteLine={(id) => deleteLine(id)}
                                lineSubmit={(data, id) => lineSubmit(data, id)}
                                headerView={view}
                                view={view}
                                currencyFormat={(amount) => currencyFormat(amount)}
                                parameterDetails={parameterDetails}
                                roleManagement={roleManagement}
                                locationDetails={locationDetails}
                                changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                checkComponentPermission={(v, page, d) => checkComponentPermission(v, page, d)}
                                search={search}
                                status={status}
                                setSearch={(s) => setSearch(s)}
                                createProduct={(data) => createProduct(data)}
                                handleBulkDelete={(selected) => handleBulkDelete(selected)}
                                batch={batch}
                                setBatch={(d) => setBatch(d)}
                                changeHandlerBatch={(e, name, i) => changeHandlerBatch(e, name, i)}
                                onDeletBatch={(d) => onDeletBatch(d)}
                            />
                        }
                    </>
                }
            />

            <CustomModal
                visible={confirm ? true : false}
                yesButton={'Yes'}
                noButton={'No'}
                title={'Stock Transfer Confirmation'}
                loading={createLoader || editLoader}
                onOpen={() => handleCommonSubmit(confirm)}
                onClose={() => setConfirm('')}
                text={< p > Are you sure do you want to {confirm} the Stock Transfer ?</p >}
            />
            <DeliveryChallan
                {...props}
                visible={visible}
                form={form}
                handleClose={() => { setVisible(!visible) }}
            />
        </Fragment>
    )
})